<span [class.offline]="isOffline()">
  {{ 'inventory-op-data.connection-state.' + connectionState() | translate }}
</span>
